export default function negativeFixer(x: number): number | string {
  return x >= 0 ? x : x * -1 + '-';
}
